import { InboxStateModel } from '../../inbox/state/model/inbox-state.model';

export const CI_STATE_PATH = 'intelligence';

export class IntelligenceStateModel {
	inbox?: InboxStateModel;
	isOrderImporter?: boolean;

	constructor() {
		this.inbox = new InboxStateModel();
		this.isOrderImporter = false;
	}
}
